export default {
  route: {
    shareRevoked: 'The owner stopped sharing this link.',
    invalidUrl: 'This URL does not point to a valid project.',
    notFound: "This geometry doesn't exist or you don't have access to it.",
  },
  dashboard: {
    columnName: 'Name',
    columnStatus: 'Status',
    columnCreated: 'Created',
    columnCompleted: 'Completed',
    columnUpdated: 'Updated',
    columnActions: 'Actions',
    saveName: 'Save name',
    cancel: 'Cancel',
    uploadTitle: 'Drop a CAD file to mesh',
    uploadSubtitle: 'STEP, STP, OBJ, or STL — up to 1 GB',
    controlsTitle: 'Meshes',
    countLabel_one: '{{count}} mesh',
    countLabel_other: '{{count}} meshes',
    searchPlaceholder: 'Search meshes…',
    typeFilter: 'Type',
    tagFilter: 'Tags',
    typeFea: 'FEA',
    typeCfd: 'CFD',
    typeCht: 'CHT',
    tagCfdExt: 'CFD · External',
    tagCfdInt: 'CFD · Internal',
    tagCht: 'CHT',
    tagFea: 'FEA',
    tagWrap: 'Wrap',
    tagRepair: 'Repair',
    tagTet: 'Tet',
    tagHex: 'Hex',
    tagPoly: 'Poly',
    noTypes: 'No types',
    noTags: 'No tags',
    clearFilter: 'Clear filter',
    tabAll: 'All',
    tabMeshing: 'Meshing',
    tabDone: 'Done',
    tabFailed: 'Failed',
    emptyTitleNone: 'No meshes yet',
    emptyTitleFiltered: 'No meshes match your filters',
    emptyHintNone: 'Upload a CAD file above to start meshing.',
    emptyHintSearchMore:
      'No matches in the loaded meshes — scroll to load more, or try a different search.',
    emptyHintFiltered: 'Try a different filter or search term.',
    loadingLabel: 'Loading meshes…',
    tableEmpty: 'No meshes available yet.',
  },
  rowActions: {
    publicTooltip: 'Public — anyone with the link can view',
    privateTooltip: 'Private — only your team can see this',
    public: 'Public',
    private: 'Private',
    downloadReady: 'Download mesh result',
    downloadDisabled: 'Download enabled only when status is Done',
    downloadMeshResult: 'Download mesh result',
    chooseFormat: 'Choose download format',
    downloadFormatMenu: 'Download formats',
    moreActions: 'More actions',
    actionsMenu: 'Geometry actions',
    makePrivate: 'Make private',
    makePublic: 'Make public',
    copyPublicLink: 'Copy public link',
    rename: 'Rename',
    delete: 'Delete',
  },
  status: {
    processing: 'Processing',
    // Compact for Status chips — full phrase still available via badge title.
    error: 'Diag. Error',
    noMesh: 'No Mesh',
    meshing: 'Meshing',
    done: 'Done',
    failed: 'Failed',
  },
  deleteDialog: {
    title: 'Delete this geometry?',
    descriptionSuffix:
      'and the meshes generated from it will be permanently removed. This can’t be undone.',
    cancel: 'Cancel',
    confirm: 'Delete geometry',
  },
  sidebar: {
    renameTooltip: 'Click to rename project',
  },
  rename: {
    notAvailable: 'Renaming isn’t available yet — coming soon.',
    failed: 'Couldn’t rename — try again.',
  },
  viewer: {
    loading: 'Loading viewer...',
  },
  workspace: {
    backToLibrary: 'Back to meshes',
  },
  restore: {
    title: 'Restoring Session',
    subtitle: 'Loading your previous work...',
    skip: 'Skip — start fresh',
  },
  tree: {
    filesHeader: 'Files',
    modeLatest: 'Latest',
    modeAll: 'All',
    containerLabel: 'MeshGen geometry tree',
    mesh: 'Mesh',
    refinement: 'Refinement',
    aiRetry: 'AI retry',
    originRepaired: 'Auto-repaired geometry',
    originManualRepaired: 'Repaired geometry',
    originUploaded: 'User-uploaded geometry',
    originSimplified: 'Simplification candidate',
    // Fuller-context tooltip strings — the sidebar icon shows the short
    // `originSimplified` label; hovering it surfaces this longer sentence
    // explaining what a "candidate" is (fuse-solids proposal awaiting the
    // user's review before it replaces the previous version in the tree).
    originRepairedTooltip:
      'This version was auto-repaired from the previous CAD. Non-manifold edges, gaps, and bad faces were fixed; the topology is the same as the original.',
    originManualRepairedTooltip:
      'This version was repaired from the previous CAD when a repair was requested. Non-manifold edges, gaps, and bad faces were fixed; the topology is the same as the original.',
    originUploadedTooltip:
      'This version is a CAD file you uploaded. Open it in the viewer to inspect or download it from the row menu.',
    originSimplifiedTooltip:
      'This version is a CAD simplification the app proposed by fusing redundant solids into one body. It is a candidate — nothing else has changed yet, and it becomes the active geometry only after you approve it. Reject it to keep the previous version.',
    expand: 'Expand',
    collapse: 'Collapse',
    previewAsCad: 'Preview as CAD tessellation',
    previewCadActive: 'Showing CAD tessellation — click for auto preview',
    downloadSourceFile: 'Download source file',
    downloadMesh: 'Download mesh',
    directionInternal: 'Int',
    directionExternal: 'Ext',
    meshStatusLabel: 'Mesh status: {{status}}',
    noSourceFile: 'No downloadable source file for this version.',
    downloadSourceFailed:
      'Couldn’t download the source file — please try again.',
  },
  meshControls: {
    resultsTitle: 'Mesh Results',
    startStudy: 'Start SimOps study',
  },
  upload: {
    uploading: 'Uploading a new version…',
    uploaded: 'New version uploaded — running a fresh diagnosis',
    failed: 'Upload failed — please try again',
  },
} as const;
